// @file get current user info
import { DOMContentLoadedPromise } from 'bits/dom'
import window, { ww } from 'bits/global'
import { User } from 'types'

// The User might not be set on `window` if the scripts have not run.
const getCurrentUser = (): User =>
  window.$currentUser ?? ww?.xstore?.state.user ?? ww?.vueStartingState?.user ?? { id: null }

// Initialize with a potentially unsafe value, then update when the DOM is ready.
let currentUser = getCurrentUser()
export const currentUserPromise = DOMContentLoadedPromise.then(getCurrentUser)
void currentUserPromise.then((user) => (currentUser = user))

export default currentUser
